export default __webpack_public_path__ + "static/media/up_arrow.2a6023eb.svg";